export class ValidationError {
    message : String;
    errors : Object; 

    constructor(){
        this.message = "";
        this.errors = {};
    }

    getField( name : string){
        return this.errors[name];
    }

    hasError( name : string ){
        return this.errors[name] != null;
    }

    flat( name : string ){
        let rc = "";

        if(this.errors[name] != null){
            rc = this.errors[name].join(" ");
        }

        return rc;
    }

    any(){
        let keys = Object.keys(this.errors);
        return keys.length > 0;
    }

    all(){
        let rc = [];
        // Generate array with messages
        for(let key in this.errors){
            let item = this.errors[key];
            // Merge
            rc = rc.concat(item);
        }


        return rc;
    }

}